import axios from 'axios';

export function getDate(dateMod, format) {
   var d = new Date(dateMod);
   format = (format != '' ? format : 'd-m-y');

   if(format === 'd-m'){
      return d.getDate() + ' ' + getMonthName(d.getMonth()).substring(0,3);
   }
   else if(format === 'd-m-y t'){
      return d.getDate() + ' ' + getMonthName(d.getMonth());
   }
   else{   
      return d.getDate() + ' ' + getMonthName(d.getMonth()) + ' ' + d.getFullYear();
   }
} 

function getMonthName(monthInt){
   const monthNames = ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];
   return monthNames[monthInt];
}

export async function getList(who, from, limit) {
   return axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
      {
         "size": limit,
         "from" : from,   
//         "track_scores": true,
//         "aggs": {
//          "S3": {
//            "terms": {
//              "field": "data.s3.iv.keyword",
//              "size": 10
//            }
//          },
//          "Aree Specializzazione": {
//            "terms": {
//              "field": "data.areeSpecializzazione.iv.keyword",
//              "size": 10
//            }
//          },
//          "Argomenti": {
//            "terms": {
//              "field": "data.argomenti.iv.keyword",
//               "size": 10
//            }
//          }
//         },
         "sort" : {"created": {"order":"desc"}},

         "query": {
            "multi_match": {
               "fields": ["name"],
               "query": who
            }
         }
      },
      {
         auth: { 
            username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
            password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
         }
      }
   ).then(response => {
      const { total, hits } = response.data.hits;
      return { total, posts: hits.map(x => parseArticolo(x)) };
   })
}

export async function search() {
   axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
      {
         "size": this.pager.limit,
         "from" : this.pager.from,   
         "track_scores": true,
         "aggs": {
          "S3": {
            "terms": {
              "field": "data.s3.iv.keyword",
              "size": 10
            }
          },
          "Aree Specializzazione": {
            "terms": {
              "field": "data.areeSpecializzazione.iv.keyword",
              "size": 10
            }
          },
          "Argomenti": {
            "terms": {
              "field": "data.argomenti.iv.keyword",
               "size": 10
            }
          }
         },
         "sort" : this.sort,
         "query": {
            "simple_query_string": {
               "query": this.query+'*',
               "flags": "ALL",
               "fuzzy_transpositions": true,
               "fuzzy_max_expansions": 50,
               "fuzzy_prefix_length": 0,
               "minimum_should_match": 1,
               "default_operator": "or",
               "lenient": true,
               "analyzer": "standard",
               "quote_field_suffix": "",
               "analyze_wildcard": false,
               "auto_generate_synonyms_phrase_query": true,
            }                                   
         }  
      },
      {
         auth: { 
            username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
            password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
         }
      }
   ).then(response => {
      this.data = response.data.hits;
      this.facets = response.data.aggregations;
      this.pager.totalResults = response.data.hits.total.value;
   })
}

export async function searchFilterd() {
   axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
      {
         "size": this.pager.limit,
         "from" : this.pager.from,   
         "track_scores": true,
         "aggs": {
          "S3": {
            "terms": {
              "field": "data.s3.iv.keyword",
              "size": 10
            }
          },
          "Aree Specializzazione": {
            "terms": {
              "field": "data.areeSpecializzazione.iv.keyword",
              "size": 10
            }
          },
          "Argomenti": {
            "terms": {
              "field": "data.argomenti.iv.keyword",
               "size": 10
            }
          }
         },
         "_source": {
            "excludes": [ "timestamp", "appId", "createdBy", "actor", "version", "partition"]
         },           
         "sort" : this.sort,

         "query": {
            "bool": {
               "must": [
                  {
                     "simple_query_string": {
                        "query": this.query+'*',
                        "flags": "ALL",
                        "fuzzy_transpositions": true,
                        "fuzzy_max_expansions": 50,
                        "fuzzy_prefix_length": 0,
                        "minimum_should_match": 1,
                        "default_operator": "or",
                        "lenient": true,
                        "analyzer": "standard",
                        "quote_field_suffix": "",
                        "analyze_wildcard": false,
                        "auto_generate_synonyms_phrase_query": true,
                     }
                  },         
                  {
                     "match": { 
                     "data.argomenti.iv.keyword": "Big Data" 
                     }
                  }
               ]
            }
         }
      },
      {
         auth: { 
            username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
            password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
         }
      }
   ).then(response => {
      this.data = response.data.hits;
      this.facets = response.data.aggregations;
      this.pager.totalResults = response.data.hits.total.value;
   })
}


export function parseArticolo(response) {   
   response = response._source;

   return {
      id: response.id,
      created: getDate(response.lastModified),
      titolo: (response.data.titolo ? response.data.titolo.iv : null),
      breve: (response.data.breve ? response.data.breve.iv : null),
      slug: (response.data.slug ? response.data.slug.iv : null),
      s3: (response.data.s3 ? response.data.s3.iv : null),
      areeSpecializzazione: (response.data.areeSpecializzazione ? response.data.areeSpecializzazione.iv : null),
      corpo: (response.data.corpo ? response.data.corpo.iv : null),
      calendarioEventi: (response.data.calendarioEventi ? response.data.calendarioEventi.iv : null),
      image: (response.data.immagineUnsplash ? response.data.immagineUnsplash.iv : null),
      immaginiList: (response.data.immaginiList ? response.data.immaginiList.iv : null),
      listaDocumenti: (response.data.listaDocumenti ? response.data.listaDocumenti.iv : null),
      linkList: (response.data.linkList ? response.data.linkList.iv : null),
      linkEsterni: (response.data.linkEsterni ? response.data.linkEsterni.iv : null),
      argomenti: (response.data.argomenti ? response.data.argomenti.iv : null),
      logo: (response.data.logo ? response.data.logo.iv : null),
      indirizzo: (response.data.indirizzo ? response.data.indirizzo.iv : null),
      sito: (response.data.sito ? response.data.sito.iv : null),
      nome: (response.data.nome ? response.data.nome.iv : null),
      destUrl: (response.data.link ? response.data.link.iv : ''),
      schema: response.schemaId.split(',').pop(),
      area: response.schemaId.split(',').pop()
   };
}